/**
 * Максимальный масштаб приближения шаринга экрана
 */
export const MAX_SHARING_ZOOM = 5;

/**
 * Минимальный масштаб приближения шаринга экрана
 */
export const MIN_SHARING_ZOOM = 1;

/**
 * Шаг приближения при нажатии кнопки
 */
export const ZOOM_BUTTON_STEP = 0.5;

/**
 * Шаг приближения при прокрутке колёсика мыши
 */
export const ZOOM_WHEEL_STEP = 0.25;
